<template lang="pug">
.viewport-lazy-render(ref="container")
  //- 使用v-if控制渲染，避免不必要的DOM操作
  .viewport-lazy-content(v-if="isVisible")
    slot
  //- 占位内容
  .viewport-lazy-placeholder(v-else-if="showPlaceholder")
    slot(name="placeholder")
</template>

<script>
export default {
  name: 'ViewportLazyRender',
  props: {
    // 触发渲染的提前量（像素）
    rootMargin: {
      type: String,
      default: '50px'
    },
    // 触发渲染的阈值（0-1）
    threshold: {
      type: [Number, Array],
      default: 0
    },
    // 是否使用占位符
    placeholder: {
      type: Boolean,
      default: false
    },
    // 是否只渲染一次（进入视口后即使离开也保持渲染）
    once: {
      type: Boolean,
      default: true
    },
    // 是否立即渲染（手动控制）
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  computed: {
    showPlaceholder() {
      return this.placeholder && !this.isVisible;
    }
  },
  mounted() {
    if (this.immediate) {
      this.isVisible = true;
      return;
    }
    this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
  methods: {
    initObserver() {
      // 检查浏览器是否支持Intersection Observer
      if (!('IntersectionObserver' in window)) {
        // 如果不支持，则立即渲染
        this.isVisible = true;
        return;
      }

      const options = {
        rootMargin: this.rootMargin,
        threshold: this.threshold
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.handleVisible();

            // 如果只需要渲染一次，则取消观察
            if (this.once) {
              this.observer.unobserve(entry.target);
            }
          } else if (!this.once) {
            // 如果不是once模式，离开视口时隐藏
            this.isVisible = false;
          }
        });
      }, options);

      this.$nextTick(() => {
        if (this.$refs.container) {
          this.observer.observe(this.$refs.container);
        }
      });
    },

    handleVisible() {
      this.isVisible = true;
      this.$emit('visible');
    },
  }
};
</script>
